import React from "react";
import PropTypes from "prop-types";
import "./toggleButton.css";

const ToggleButton = ({
    onChange,
    right_label,
    right_label_style,
    left_label,
    left_label_style,
    disabled,
    style,
    is_toggled,
    inputClassName,
    containerClassName
}) => {
    return (
        <div className={`custom-switch custom-switch-md float-right ${containerClassName}`}>
            {left_label && 
            <p className="left-side-label" style={left_label_style}>
                {left_label}
            </p>
            }
            <input
                style={{...style}}
                type="checkbox"
                className={`custom-control-input ${inputClassName}`}
                id="customSwitches"
                disabled={disabled}
                onChange={e => onChange(e)}
                checked={is_toggled}
            />
            <label
                className="custom-control-label"
                htmlFor="customSwitches"
                style={{
                    ...right_label_style,
                    fontSize: 16,
                }}
            >
                {right_label}
            </label>
        </div>
    );
};

ToggleButton.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onChange: PropTypes.func.isRequired,
};


export default ToggleButton;
